var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4816 5.26575C11.143 5.26575 10.6944 5.25825 10.136 5.25825C8.77403 5.25825 7.65413 4.131 7.65413 2.75625V0.34425C7.65413 0.1545 7.5027 0 7.31475 0H3.34772C1.49638 0 0 1.5195 0 3.38175V11.463C0 13.4167 1.56767 15 3.50219 15H9.40973C11.2544 15 12.75 13.4902 12.75 11.6265V5.60325C12.75 5.41275 12.5993 5.259 12.4106 5.25975C12.0935 5.262 11.7133 5.26575 11.4816 5.26575Z",
    fill: "#86A0D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43802 0.425527C9.21377 0.192277 8.82227 0.352777 8.82227 0.676027V2.65378C8.82227 3.48328 9.50551 4.16578 10.335 4.16578C10.8578 4.17178 11.5838 4.17328 12.2003 4.17178C12.516 4.17103 12.6765 3.79378 12.4575 3.56578C11.6663 2.74303 10.2495 1.26853 9.43802 0.425527Z",
    fill: "#86A0D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0841 7.54569L11.0841 7.54569L11.0818 7.54538C10.8747 7.5173 10.6699 7.50352 10.4648 7.50007L10.4648 7.5H10.4564C7.97253 7.5 5.95801 9.51453 5.95801 11.9984C5.95801 12.7741 6.15561 13.5046 6.50102 14.1428C7.25948 15.5467 8.74841 16.5 10.4564 16.5C12.9403 16.5 14.9548 14.4854 14.9548 12.0015C14.9548 9.72898 13.2717 7.85252 11.0841 7.54569Z",
    fill: "#B5CAF3",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 9.68763C10.6197 9.62496 10.5381 9.58728 10.4504 9.58728C10.3625 9.58728 10.281 9.62496 10.2214 9.68763L8.38363 11.6603C8.26453 11.7857 8.27395 11.9864 8.39939 12.1023C8.45889 12.1588 8.53741 12.1871 8.61268 12.1871C8.69727 12.1871 8.78504 12.1525 8.8478 12.0868L10.1461 10.6974V14.1221C10.1461 14.2945 10.2872 14.4357 10.4597 14.4357C10.6322 14.4357 10.7733 14.2945 10.7733 14.1221V10.6974L12.0622 12.0868C12.1814 12.2122 12.3759 12.2215 12.5044 12.1023C12.6298 11.9832 12.6361 11.7857 12.5201 11.6603L10.6792 9.68763Z",
    fill: "#526B9C",
    stroke: "#526B9C",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDoc);
export default __webpack_public_path__ + "static/media/uploadDoc.278fc2598d7003043d779c0af6ab42eb.svg";
export { ForwardRef as ReactComponent };